import React from "react";

/**
 * component svg go-btn
 */
const GoButton = function (props) {

    return (
        <svg id="go-button" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 1000 1000">

            <polyline
            className="st1-go"
            points="371.7,481.9 500,609.9 628.3,481.9 "
            transform="matrix(0,-1.4834458,1.4856134,0,-92.453824,1228.1491)"/>
            <line
            className="st0-go"
            x1="810.69312"
            y1="486.42624"
            x2="206.34099"
            y2="486.42624"/>

        </svg>
    );
};

export default GoButton;
